import React from 'react';
import { connect } from 'react-redux';

import { selectOldFlagsHideMiniModal } from 'selectors/oldFlags.selectors';

const NavTabs = ({ bookedByButton, hideMiniModal, history, selected, setType }) => (
  <div>
    <ul className="tabs-menu">
      {history.location.pathname.indexOf('/timeoff') < 0 && (
        <div
          className={selected === 'booking' ? 'tab-item selected' : 'tab-item'}
          role="button"
          tabIndex={0}
          onClick={() => {
            const path = history.location.pathname
              .split('/')
              .filter((e) => e !== 'timeoff')
              .join('/');
            setType('booking');
            history.push(path);
          }}
        >
          New booking
        </div>
      )}

      {!bookedByButton && (selected === 'timeOff' || hideMiniModal) && (
        <div
          style={{ cursor: 'default' }}
          className={selected === 'timeOff' ? 'tab-item selected' : 'tab-item'}
          role="button"
          tabIndex={0}
          onClick={() => {
            if (!hideMiniModal) return;
            history.push('timeoff');
            setType('timeoff');
          }}
        >
          Time off & Holidays
        </div>
      )}
    </ul>
  </div>
);

const mapStateToProps = (state) => ({
  hideMiniModal: selectOldFlagsHideMiniModal(state),
});

const NavTabsHoc = connect(mapStateToProps)(NavTabs);

export default NavTabsHoc;
